import { runInAction } from 'mobx'
import { deserialize } from 'serializr'
import { importFromProject } from 'utils/importHelper'
import { subcontentDataAdapter } from '../cmsAdapters/subcontentDataAdapter'
import { FullscreenSubcontent } from './fullscreenSubcontent'
import { IRawSubcontentData } from './subcontentInterfaces'

export { FullscreenSubcontent } from './fullscreenSubcontent'

export async function createSubcontent(
  subcontentDataItem: IRawSubcontentData,
  parms = {}
): Promise<FullscreenSubcontent | null> {
  let clazz: (new () => FullscreenSubcontent) | null = null
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let subcontentType: any
  let res: FullscreenSubcontent | null = null
  const shouldThrowModuleLoadingError = true
  try {
    //1. Try to import cover from specific project (ex. path: src/projects/carllutz/componenets/Cover)
    subcontentType = await importFromProject(
      `subcontent_modules/${subcontentDataItem.type}/subcontent.tsx`,
      shouldThrowModuleLoadingError
    )
  } catch (err) {
    try {
      subcontentType = (await import(`./${subcontentDataItem.type}`)).default
    } catch (err) {
      subcontentType = null
    }
  }

  const parseData = (await subcontentDataAdapter())[subcontentDataItem.type]
  if (subcontentType) {
    runInAction(() => {
      clazz = subcontentType
      res = deserialize(
        clazz!, // eslint-disable-line
        parseData(subcontentDataItem.data),
        undefined,
        parms
      )
    })
  }
  return res
}
